
export default {
  name: "FiltrosDeVenda",

  data: () => ({
    filtros: {
      status: "",
      nome_plano: "",
      nome_vendedor: "",
      nome_unidade: "",
      nome: "",
      id: "",
    },
    listaDeStatus: [
      {
        value: "em análise",
        text: "em análise",
      },
      {
        value: "aguardando análise",
        text: "aguardando análise",
      },
      {
        value: "rejeitado",
        text: "rejeitado",
      },
      {
        value: "aprovada",
        text: "aprovada",
      },
      {
        value: "aguardando cancelamento",
        text: "aguardando cancelamento",
      },
      {
        value: "cancelado",
        text: "cancelado",
      },
    ],
    listaDePlanos: [
      {
        value: "Flex Familia",
        text: "Flex Familia",
      },
      {
        value: "Flex Familia Rio",
        text: "Flex Familia Rio",
      },
      {
        value: "Flex Multi",
        text: "Flex Multi",
      },
      {
        value: "Flex Multi Top",
        text: "Flex Multi Top",
      },
    ],
    listaDeUnidades: [
      {
        value: "ILHA",
        text: "Ilha",
      },
      {
        value: "ALCÂNTARA",
        text: "Alcântara",
      },
      {
        value: "NITERÓI",
        text: "Niterói",
      },
    ],
  }),

  methods: {
    filtrar() {
      let filtros = this.filtros;
      Object.keys(filtros).forEach((key) => {
        if (!filtros[key]) {
          delete filtros[key];
        }
      });
      this.$emit("filtrar", filtros);
    },
    clear() {
      this.filtros.status = "";
      this.filtros.nome_plano = "";
      this.filtros.nome_vendedor = "";
      this.filtros.nome_unidade = "";
      this.filtros.nome = "";
      this.filtros.id = "";
    },
  },

  props: {
    id: Boolean,
    status: Boolean,
    contratantes: Boolean,
    planos: Boolean,
    listaDeContratantes: Array,
    listaDeVendedores: Array,
    modo: String,
  },
};
